export default __webpack_public_path__ + "84e969743ec45e20dfdcabde514503f4.svg";